import OmmnioDataGrid from './OmmnioDataGrid';

export default OmmnioDataGrid;
